import React, { memo } from "react";
import styles from "./styles/Product.module.css";
import cx from "classnames";
import { Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const Product = ({ product, loadingDeta, openDataCard }) => {
  const {
    quantity,
    name,
    isCard,
    cardData,
    product_categories = [],
    comments,
    total,
  } = product;

  // Total por producto
  console.log(product_categories);
  const total_extras = product_categories.flatMap(item => item.id_product_category === 1 ? [] : item.extras || []).reduce((acc, extra) => acc + (extra.quantity===1?0:extra.price || 0), 0);
  const totalProd = Number(total) + Number(total_extras);

  return (
    <div className={styles.product}>
      <div className={cx(styles.productName, styles.green)}>
        <span>{`(${quantity}) ${name} - `}</span>
        {isCard && (
          <button
            disabled={loadingDeta}
            className={styles.btnCardIcon}
            onClick={() => openDataCard(name, cardData)}
          >
            {loadingDeta ? <Spin size="small" /> : <SearchOutlined />}
          </button>
        )}
      </div>

      <div className={styles.details}>
        {product_categories.map((category) => (
          <div key={category.id}>
            <span>{category.name}</span>
            <div className={styles.extraLine}>
              {category.extras.map((extra) => (
                <span key={extra.id} className={styles.extraItem}>
                  <span className={styles.bullet}>•</span> 
                  {extra.name}
                  {
                    extra.price > 0 ? " •  +$"+extra.price: ""
                  }
                </span>
              ))}
            </div>
          </div>
        ))}

        {comments && (
          <div className={styles.annotations}>
            <span>
              <span className={styles.labelNotes}>Nota:</span> {comments}
            </span>
          </div>
        )}
      </div>

      <div className={styles.totalProduct}>
        <span className={styles.price}>
          {`$${parseFloat(totalProd).toFixed(2)}`}
        </span>
      </div>
    </div>
  );
};

export default memo(Product);
